module.exports = __webpack_public_path__ + "img/rail-endings-metals.2dbd6c01.png";